import * as Yup from 'yup';
import { isValid } from 'iban';

export const bancoValidationSchema = Yup.object().shape({
  documentoTercero: Yup.string()
    .required('El Documento del Tercero es obligatorio')
    .typeError('El Documento del Tercero debe ser una cadena de texto válida'),

  descripcion: Yup.string()
    .typeError('La descripción debe ser una cadena de texto válida'),

  nombreBanco: Yup.string()
    .required('El nombre del banco es obligatorio')
    .typeError('El nombre del banco debe ser una cadena de texto válida'),

  iban: Yup.string()
    .required('El IBAN es obligatorio')
    .test('is-iban', 'El IBAN debe ser un número de cuenta válido', (value) => isValid(value)),
});

export const validateBancoForm = async (formData) => {
  try {
    await bancoValidationSchema.validate(formData, { abortEarly: false });
    return {};
  } catch (error) {
    const errors = {};
    if (error.inner) {
      error.inner.forEach((err) => {
        errors[err.path] = err.message;
      });
    }
    return errors;
  }
};